export default {
    //从url中获取参数值
    getCreateLostOrderPath(page, invoice, orderId, isVipNotPay) {
        return `/createOrder/${page}/${invoice}/${orderId}${isVipNotPay?'/'+isVipNotPay:''}`
    }
};
